export const PRODUCTS = [
  {
    slug: "adjustable-props",
    name: "Adjustable Props",
    tagline: "Rock-solid vertical support for every slab.",
    description:
      "Heavy-duty adjustable steel props fabricated from 32 NB pipe, built to carry slab and beam loads through every pour. Rolled self-cleaning threads make height setting fast, even in site dust and slurry.",
    features: [
      "32 NB heavy-duty steel tube construction",
      "Adjustable heights from 1800 mm to 5500 mm",
      "Self-cleaning rolled threads for quick setting",
      "Powder-coated / painted finish for long site life",
    ],
    image: "/images/props.jpg",
    table: {
      title: "Available Sizes (32 NB Pipe)",
      columns: ["Prop Type", "Closed Height", "Extended Height"],
      rows: [
        ["Prop 1.8 – 3.0 m", "1800 mm", "3000 mm"],
        ["Prop 2.0 – 3.5 m", "2000 mm", "3500 mm"],
        ["Prop 2.5 – 4.5 m", "2500 mm", "4500 mm"],
        ["Prop 3.0 – 5.5 m", "3000 mm", "5500 mm"],
      ],
    },
  },
  {
    slug: "adjustable-spans",
    name: "Adjustable Spans",
    tagline: "Precision horizontal support between props.",
    description:
      "Telescopic adjustable spans that replace timber runners entirely. Set your exact bay width in seconds and reuse them pour after pour without warping, nails or waste.",
    features: [
      "Telescopic inner–outer steel sections",
      "Adjustable lengths from 1200 mm to 2600 mm",
      "Eliminates timber runners and carpentry time",
      "High stiffness for consistent slab levels",
    ],
    image:
      "/images/spans.jpg",
    table: {
      title: "Available Sizes",
      columns: ["Span Type", "Closed Length", "Extended Length"],
      rows: [
        ["Span 1.2 – 1.8 m", "1200 mm", "1800 mm"],
        ["Span 1.6 – 2.2 m", "1600 mm", "2200 mm"],
        ["Span 2.0 – 2.6 m", "2000 mm", "2600 mm"],
      ],
    },
  },
  {
    slug: "h-frame-scaffolding",
    name: "H Frame Scaffolding",
    tagline: "The workhorse of Indian construction sites.",
    description:
      "Rigid welded H frames that stack fast and stay true. Ideal for masonry, plastering, facade work and slab support — the most economical access system for repetitive floors.",
    features: [
      "Welded frames in 1700 mm and 2000 mm heights",
      "Quick stacking with cross braces and joint pins",
      "Uniform bays for safe, level working platforms",
      "Compatible with base jacks and walkway jali",
    ],
    image:
      "/images/h-frame.jpg",
    table: {
      title: "Standard Frames",
      columns: ["Frame Height", "Frame Width", "Pipe"],
      rows: [
        ["1700 mm", "1000 mm", "40 NB"],
        ["2000 mm", "1000 mm", "40 NB"],
      ],
    },
  },
  {
    slug: "cuplock-system",
    name: "Cuplock System",
    tagline: "Fast, modular, and built for repetition.",
    description:
      "The proven cuplock modular system for heavy falsework and access. One hammer blow locks up to four ledgers at a node — no nuts, bolts or loose fittings to lose on site.",
    features: [
      "Node locking with a single hammer blow",
      "No loose fittings, nuts or bolts",
      "High load capacity for heavy falsework",
      "Galvanised / painted options available",
    ],
    image:
      "/images/cuplock.jpg",
    table: {
      title: "Standard Components",
      columns: ["Component", "Sizes"],
      rows: [
        ["Verticals / Standards", "1.0 m / 1.5 m / 2.0 m / 3.0 m"],
        ["Horizontal Ledgers", "0.6 m / 0.9 m / 1.2 m / 1.5 m"],
      ],
    },
  },
  {
    slug: "walkway-jali",
    name: "Walkway Jali / Steel Planks",
    tagline: "Anti-skid, safe access at every level.",
    description:
      "Perforated anti-skid steel walkway planks with hooked ends that sit securely on ledger tubes. A rigid, slip-resistant platform your crew can trust at any height.",
    features: [
      "Anti-skid perforated steel surface",
      "Widths from 210 mm to 400 mm, 38 mm height",
      "Hooked ends lock onto scaffold ledgers",
      "Far longer life than timber planks",
    ],
    image:
      "/images/jali.jpg",
    table: {
      title: "Available Sizes",
      columns: ["Height × Width", "Length Options"],
      rows: [
        ["38 × 210 mm", "1.0 – 2.5 m"],
        ["38 × 250 mm", "1.0 – 2.5 m"],
        ["38 × 300 mm", "1.0 – 2.5 m"],
        ["38 × 400 mm", "1.0 – 2.5 m"],
      ],
    },
  },
  {
    slug: "centring-sheets",
    name: "Centring Sheets",
    tagline: "A flawless soffit finish, every pour.",
    description:
      "Pressed steel centring sheets with stiffened edges for deck formwork. They lay flat, pour after pour, leaving a clean concrete soffit that needs minimal finishing.",
    features: [
      "Thickness options: 1.2 / 1.6 / 2.0 / 2.5 mm",
      "Stiffened pressed edges resist warping",
      "Smooth face for a clean soffit finish",
      "Custom sizes fabricated on request",
    ],
    image:
      "/images/sheets.jpg",
    table: {
      title: "Thickness Options",
      columns: ["Thickness", "Standard Size"],
      rows: [
        ["1.2 mm", "600 × 900 mm"],
        ["1.6 mm", "600 × 900 mm"],
        ["2.0 mm", "600 × 900 mm"],
        ["2.5 mm", "600 × 900 mm"],
      ],
    },
  },
  {
    slug: "adjustable-base-jack",
    name: "Adjustable Base Jack",
    tagline: "Level foundations on any terrain.",
    description:
      "Adjustable base jacks that absorb uneven ground and set your scaffold perfectly plumb. Solid or hollow stems with a wide bearing plate for stable load transfer.",
    features: [
      "38 mm solid or hollow threaded stem",
      "Up to 600 mm of height adjustment",
      "150 × 150 mm steel base plate",
      "Fits cuplock, H-frame and tube systems",
    ],
    image:
      "/images/base-jack.jpg",
    table: {
      title: "Specifications",
      columns: ["Stem", "Adjustment", "Base Plate"],
      rows: [["38 mm solid / hollow", "Up to 600 mm", "150 × 150 mm"]],
    },
  },
  {
    slug: "adjustable-u-head-jack",
    name: "Adjustable U Head Jack",
    tagline: "Cradles beams and channels with precision.",
    description:
      "U head jacks that seat timber or steel beams securely at the top of your falsework. Fine height adjustment lets you strike the exact soffit level every time.",
    features: [
      "U-head cradle for beams and channels",
      "38 mm solid or hollow threaded stem",
      "Up to 600 mm of fine height adjustment",
      "Pairs with props, cuplock and frames",
    ],
    image:
      "/images/u-head-jack.jpg",
    table: {
      title: "Specifications",
      columns: ["Stem", "Adjustment", "U Head"],
      rows: [["38 mm solid / hollow", "Up to 600 mm", "100 × 100 mm cradle"]],
    },
  },
  {
    slug: "customised-scaffolding",
    name: "Customised Scaffolding Solutions",
    tagline: "If you can draw it, we can fabricate it.",
    description:
      "Non-standard heights, unusual bay widths, special load cases — our Bengaluru fabrication unit builds scaffolding and formwork to your drawings, at catalogue quality.",
    features: [
      "Fabrication to your drawings and site needs",
      "Custom sizes across props, frames and jacks",
      "In-house welding, pressing and finishing",
      "Batch orders with consistent QC",
    ],
    image:
      "/images/custom.jpg",
    table: null,
  },
];
